import { render, staticRenderFns } from "./PermissionToContact.vue?vue&type=template&id=2dfa3925"
import script from "./PermissionToContact.vue?vue&type=script&lang=js"
export * from "./PermissionToContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports